import { CashOrCredit } from '@app/dashboard/sheets/shared/ea-simulation-packs/simulation-pack.service';

/**
 * Mode de financement d'une souscription SCPI : seule la pleine propriété à crédit est financée à crédit.
 */
export function cashOrCreditOfScpiOwnership(
  scpiOwnershipType: string | undefined,
): CashOrCredit {
  return scpiOwnershipType === 'PLEINE_PROPRIETE_CREDIT' ? 'CREDIT' : 'CASH';
}
